"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hasChildren = _interopRequireDefault(require("../utils/hasChildren"));

var _propTypes2 = require("../propTypes");

var _TableBody = _interopRequireDefault(require("../TableBody/TableBody"));

var ExpandableRow =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ExpandableRow, _Component);

  function ExpandableRow() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ExpandableRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ExpandableRow)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onToggleExpand", function () {
      var rowData = _this.props.rowData;

      _this.props.onExpandRow(rowData.__key, rowData);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderExpandedRows", function () {
      var _this$props = _this.props,
          rowData = _this$props.rowData,
          indentLevel = _this$props.indentLevel,
          renderRow = _this$props.renderRow,
          onExpandRow = _this$props.onExpandRow,
          draggable = _this$props.draggable,
          expandedKeys = _this$props.expandedKeys;

      if (!(0, _hasChildren.default)(rowData)) {
        return [];
      }

      if (expandedKeys.indexOf(rowData.__key) === -1) {
        return [];
      }

      return _react.default.createElement(_TableBody.default, {
        key: "expanded-".concat(rowData.__key),
        data: rowData.children,
        renderRow: renderRow,
        indentLevel: indentLevel + 1,
        onExpandRow: onExpandRow,
        draggable: draggable,
        expandedKeys: expandedKeys
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ExpandableRow, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          partiallyAppliedRenderRow = _this$props2.partiallyAppliedRenderRow,
          expandedKeys = _this$props2.expandedKeys,
          rowData = _this$props2.rowData;
      var expanded = expandedKeys.indexOf(rowData.__key) !== -1;
      var expandedRows = this.renderExpandedRows();
      return [partiallyAppliedRenderRow({
        isExpanded: expanded,
        onToggleExpand: this.onToggleExpand
      }), expandedRows];
    }
  }]);
  return ExpandableRow;
}(_react.Component);

ExpandableRow.propTypes = {
  rowData: _propTypes2.rowPropType.isRequired,
  indentLevel: _propTypes.default.number.isRequired,
  partiallyAppliedRenderRow: _propTypes.default.func.isRequired,
  renderRow: _propTypes.default.func.isRequired,
  onExpandRow: _propTypes.default.func.isRequired,
  expandedKeys: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = ExpandableRow;
exports.default = _default;